module.exports = __webpack_public_path__ + "img/1_calvin.b4d0d357.jpg";